(() => {
  if (window.__sharpInterfacePolish20260916) return;
  window.__sharpInterfacePolish20260916 = true;

  const ua = navigator.userAgent || '';
  const isSafari = /Safari/i.test(ua) && !/(Chrome|CriOS|Chromium|Edg|EdgiOS|OPR|OPiOS|SamsungBrowser|FxiOS|Firefox)/i.test(ua);
  const hasTouch = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
  const isMobileTouch = hasTouch && window.matchMedia('(max-width: 1199px)').matches;

  const applySafariEggContrast = () => {
    if (!isSafari || isMobileTouch) return;
    const reveal = document.querySelector('.sharp-overscroll-easter-egg');
    if (!reveal) return;
    reveal.style.setProperty('color', 'var(--sharp-easter-egg-color, #111)', 'important');
    reveal.style.setProperty('mix-blend-mode', 'normal', 'important');
    reveal.style.setProperty('text-shadow', 'none', 'important');
  };

  const previewSafeUrl = (path) => {
    const target = new URL(path, window.location.origin);
    const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewId) target.searchParams.set('preview_theme_id', previewId);
    return `${target.pathname}${target.search}${target.hash}`;
  };

  const setQuickAddLabel = (button) => {
    if (!(button instanceof Element) || button.querySelector('.sharp-mobile-action')) return;
    for (const node of button.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim().toLowerCase() === 'choose options') { node.textContent = 'Choose'; return; }
    }
    const label = Array.from(button.children).find((child) => child.textContent.trim().toLowerCase() === 'choose options' && !child.classList.contains('loading__spinner'));
    if (label) label.textContent = 'Choose';
  };

  const convertQuickAddChooser = (button) => {
    if (!(button instanceof Element)) return;
    const opener = button.closest('modal-opener[data-modal^="#QuickAdd-"]');
    const productUrl = button.getAttribute('data-product-url');
    if (!productUrl) { setQuickAddLabel(button); return; }
    const link = document.createElement('a');
    link.href = previewSafeUrl(productUrl);
    link.id = button.id;
    link.className = button.className;
    link.dataset.sharpProductLink = '';
    const labelledBy = button.getAttribute('aria-labelledby');
    if (labelledBy) link.setAttribute('aria-labelledby', labelledBy);
    const compactLabel = button.querySelector('.sharp-mobile-action');
    if (compactLabel) {
      const desktopLabel = document.createElement('span');
      desktopLabel.className = 'sharp-desktop-action';
      desktopLabel.textContent = 'Choose';
      link.append(desktopLabel, compactLabel.cloneNode(true));
    } else link.append(document.createTextNode('Choose'));
    const icon = button.querySelector('.icon-wrap');
    if (icon) link.append(document.createTextNode(' '), icon.cloneNode(true));
    if (opener) {
      const modal = opener.nextElementSibling;
      opener.replaceWith(link);
      if (modal?.matches('quick-add-modal')) modal.remove();
    } else {
      button.replaceWith(link);
    }
  };

  const polishQuickAddButtons = (root = document) => {
    const chooseSelector = '.product-card-wrapper .quick-add__submit[data-product-url]:not([disabled])';
    const buttonSelector = '.product-card-wrapper .quick-add__submit';
    if (root.matches?.(chooseSelector)) convertQuickAddChooser(root);
    root.querySelectorAll?.(chooseSelector).forEach(convertQuickAddChooser);
    if (root.matches?.(buttonSelector)) setQuickAddLabel(root);
    root.querySelectorAll?.(buttonSelector).forEach(setQuickAddLabel);
  };

  const getFreeShippingThreshold = () => {
    const message = document.querySelector('.announcement-bar-section .announcement-bar__message')?.textContent || '';
    const match = message.replace(/,/g, '').match(/\$(\d+(?:\.\d+)?)/);
    const parsed = match ? Number(match[1]) : 50;
    return Number.isFinite(parsed) && parsed > 0 ? Math.round(parsed * 100) : 5000;
  };

  const formatCartMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: cents % 100 === 0 ? 0 : 2 }).format(cents / 100); }
    catch (error) { return `$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)}`; }
  };

  const getCartShippingMounts = () => {
    const candidates = [document.querySelector('cart-drawer .drawer__footer .cart-drawer__footer'), document.querySelector('#cart-notification .cart-notification__links'), document.querySelector('#main-cart-footer .cart__blocks')];
    return candidates.filter((node, index) => node && candidates.indexOf(node) === index);
  };

  const buildCartShippingWidget = () => {
    const widget = document.createElement('div');
    widget.className = 'sharp-cart-shipping';
    widget.dataset.sharpCartShipping = '';
    widget.setAttribute('aria-live', 'polite');
    widget.innerHTML = '<div class="sharp-cart-shipping__row"><span class="sharp-cart-shipping__copy"></span><span class="sharp-cart-shipping__check" aria-hidden="true">&#10003;</span></div><div class="sharp-cart-shipping__track" role="progressbar" aria-label="Free shipping progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span class="sharp-cart-shipping__fill"></span></div>';
    return widget;
  };

  const ensureCartShippingProgress = () => getCartShippingMounts().map((mount) => {
    let widget = mount.querySelector(':scope > [data-sharp-cart-shipping]');
    if (widget) return widget;
    widget = buildCartShippingWidget();
    mount.prepend(widget);
    return widget;
  });

  let cartShippingTimer = null;
  let cartShippingRequest = 0;

  const updateCartShippingWidget = (widget, cart, threshold) => {
    const total = Number(cart.total_price) || 0;
    const remaining = Math.max(threshold - total, 0);
    const progress = Math.min(Math.round((total / threshold) * 100), 100);
    const unlocked = remaining === 0 && cart.item_count > 0;
    const copy = widget.querySelector('.sharp-cart-shipping__copy');
    const track = widget.querySelector('.sharp-cart-shipping__track');
    const fill = widget.querySelector('.sharp-cart-shipping__fill');
    widget.hidden = cart.item_count === 0;
    widget.dataset.unlocked = unlocked ? 'true' : 'false';
    const message = unlocked ? 'You unlocked free shipping' : `You're ${formatCartMoney(remaining)} away from free shipping`;
    if (copy && copy.textContent !== message) copy.textContent = message;
    if (track) track.setAttribute('aria-valuenow', String(progress));
    if (fill) fill.style.setProperty('--sharp-shipping-progress', `${progress}%`);
  };

  const updateCartShippingProgress = async () => {
    const widgets = ensureCartShippingProgress();
    if (!widgets.length) return;
    const requestId = ++cartShippingRequest;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestId !== cartShippingRequest) return;
      const threshold = getFreeShippingThreshold();
      widgets.forEach((widget) => updateCartShippingWidget(widget, cart, threshold));
    } catch (error) { widgets.forEach((widget) => { widget.hidden = true; }); }
  };

  const scheduleCartShippingProgress = (delay = 80) => { window.clearTimeout(cartShippingTimer); cartShippingTimer = window.setTimeout(updateCartShippingProgress, delay); };

  const isCartUiNode = (node) => {
    if (!(node instanceof Element)) return false;
    if (node.closest('[data-sharp-cart-shipping]')) return false;
    return Boolean(node.matches('cart-drawer, #cart-notification, #main-cart-footer, .cart-drawer__footer, .drawer__footer, .cart__blocks') || node.closest('cart-drawer, #cart-notification, #main-cart-footer') || node.querySelector('cart-drawer, #cart-notification, #main-cart-footer, .cart-drawer__footer, .drawer__footer, .cart__blocks'));
  };

  let observer = null;
  const observe = () => {
    if (observer || !document.body) return;
    observer = new MutationObserver((records) => {
      let cartChanged = false;
      records.forEach((record) => {
        if (isCartUiNode(record.target)) cartChanged = true;
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          polishQuickAddButtons(node);
          syncCardColorDefaults(node);
          if (isCartUiNode(node)) cartChanged = true;
        });
      });
      if (cartChanged) scheduleCartShippingProgress();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };


  const applyCardColorState = (button, activate = false) => {
    if (!(button instanceof Element)) return;

    const group = button.closest('[data-sharp-card-colors]');
    const card = group?.closest('.product-card-wrapper');
    if (!group || !card) return;

    if (activate) {
      group.querySelectorAll('[data-sharp-card-color-swatch]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    const label = group.querySelector('[data-sharp-card-color-label]');
    if (label) label.textContent = button.dataset.sharpCardColor || '';

    const imageUrl = button.dataset.sharpCardImage;
    if (imageUrl) {
      card.querySelectorAll('.card__media source').forEach((source) => {
        source.setAttribute('srcset', imageUrl);
        source.removeAttribute('sizes');
      });
      card.querySelectorAll('.card__media img:not([data-sharp-bag-open-image]):not(.nicholls-model-hover-image)').forEach((img) => {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = imageUrl;
      });
    }

    if (button.dataset.sharpCardPrice) {
      const price = card.querySelector('.card-information .price');
      if (price) {
        price.classList.remove('price--on-sale');
        price.querySelectorAll('.price-item--regular').forEach((node) => { node.textContent = button.dataset.sharpCardPrice; });
      }
    }

    const productUrl = button.dataset.sharpCardUrl;
    if (productUrl) {
      const safeUrl = previewSafeUrl(productUrl);
      card.querySelectorAll('.card__heading a, .card__inner a, a.product__view-details, [data-sharp-product-link]').forEach((link) => {
        link.href = safeUrl;
      });
      card.querySelectorAll('[data-product-url]').forEach((target) => {
        target.setAttribute('data-product-url', productUrl);
      });
    }
  };

  const syncCardColorDefaults = (root = document) => {
    const groups = [];
    if (root.matches?.('[data-sharp-card-colors]')) groups.push(root);
    root.querySelectorAll?.('[data-sharp-card-colors]').forEach((group) => groups.push(group));

    groups.forEach((group) => {
      const active = group.querySelector('[data-sharp-card-color-swatch].is-active, [data-sharp-card-color-swatch][aria-pressed="true"]');
      const button = active || group.querySelector('[data-sharp-card-color-swatch]');
      if (!button) return;
      applyCardColorState(button, !active);
    });
  };

  let cardColorTogglesBound = false;
  const bindCardColorToggles = () => {
    if (cardColorTogglesBound) return;
    cardColorTogglesBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-sharp-card-color-swatch]');
      if (!button) return;

      const group = button.closest('[data-sharp-card-colors]');
      const card = group?.closest('.product-card-wrapper');
      if (!group || !card) return;

      event.preventDefault();
      event.stopPropagation();

      applyCardColorState(button, true);
    });
  };

  const boot = () => {
    bindCardColorToggles();
    syncCardColorDefaults();
    polishQuickAddButtons();
    observe();
    applySafariEggContrast();
    scheduleCartShippingProgress(20);
    window.setTimeout(applySafariEggContrast, 180);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  window.addEventListener('pageshow', () => { syncCardColorDefaults(); scheduleCartShippingProgress(20); }, { passive: true });
  window.addEventListener('resize', applySafariEggContrast, { passive: true });
  window.addEventListener('orientationchange', () => window.setTimeout(applySafariEggContrast, 120), { passive: true });
  document.addEventListener('shopify:section:load', () => window.requestAnimationFrame(boot));
})();
